import { Navigate } from "react-router-dom";
import { ReactNode } from "react";
import { jwtDecode } from "jwt-decode";

import { BreakGlassSetupDialog } from "@/components/BreakGlassSetupDialog";
import { useAuth } from "@/context/auth-context";
import { DecodedToken } from "@/utils/postLoginNavigation";

interface ProtectedRouteProps {
  children: ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const auth = useAuth();
  const isVerified = !!auth?.user?.verified;
  const isNewUser = !!auth?.user?.workos_user_id;

  if (import.meta.env.REACT_APP_MAINTENANCE_MODE === "true") {
    return <Navigate to="/maintenance" />;
  }

  if (!auth?.userToken || !auth?.user) {
    return <Navigate to="/login" />;
  }

  if (!isVerified && isNewUser) {
    return <Navigate to={`/verify-email?email=${encodeURIComponent(auth?.user?.email || "")}`} />;
  }

  if (auth?.user?.mfa_type) {
    const decoded = jwtDecode<DecodedToken>(auth?.userToken ?? "");
    const { mfa_verified } = decoded;

    if (!mfa_verified) {
      return <Navigate to="/verify-mfa" />;
    }
  }

  return (
    <>
      {children}
      <BreakGlassSetupDialog />
    </>
  );
};
